<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />

    <div class="margintop-32" />
    <tl-header type="h1">Organisation Utilities</tl-header>
    <div class="twoColumnGridDashboard marginbottom-5p">
      <div class="utility-container" v-for="(nav, index) in navList" :key="index">
        <div class="cursor-pointer" :class="nav.url ? '': 'disabledMode'" @click="navigateToUtility(nav.url)">{{ nav.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  components: {},
  data() {
    return {
      navList: [
        {
            name : "Download/Upload Master Template",
            //url: ''
           url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/downloaduploadmastertemplate`
        },
        // {
        //     name: "Salary Component",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/salarymanagement`
        // },
        {
            name: "ESS Login",
            //url: ''
             url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/essLogin`
        },
        // {
        //     name: "FBP Settings",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/fbpsettingsandcomponentmapping`
        // },
        {
            name: "ESS Management",
            // url: ''
            url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/essManagement`
        },
        // {
        //     name: "IT Declarations",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/ITdeclarations`
        // },
        // {
        //     name: "Add Leave Inputs",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/addLeaveInputs`
        // },
        {
            name: "Payslips & IT Sheets",
            url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/download_payslips`
        },
        // {
        //     name: "Salary Component",
        //     url: ''
        //     // url:  `/dashboard/${this.$route.params.entity_index}/organisation/utilities/salarycomponent`
        // },
        // {
        //     name: "Salary Structure",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/salarystructure`
        // },
        // {
        //     name: "Voluntary PF",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/voluntaryPf`
        // },
        // {
        //     name: "Configure Events",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/events`
        // },
        // {
        //     name: "Form 16 Annexure",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/form_annexure`
        // },
        // {
        //     name: "IT Remittence",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/itremittence`
        // },
        // {
        //     name: "Password Policy",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/passwordPolicy`
        // },
        // {
        //     name: "Assign Perks",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/assignperk`
        // },
        // {
        //     name: "Upload Policy Document",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/policyDocument`
        // },
        // {
        //     name: "Reset Password",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/resetPassword`
        // },
        // {
        //     name: "Form 16",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/form16`
        // },
        {
            name: "Process FNF",
            // url: ''
            url:  `/dashboard/${this.$route.params.entity_index}/organisation/utilities/fnf`
        },
        {
            name: "Bulk Payslip",
            // url: ''
            url:  `/dashboard/${this.$route.params.entity_index}/organisation/utilities/download_bulk_payslips`
        },
        // {
        //     name: "Update Form 24Q acknowledgement",
        //     //url: ''
        //     url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/form24q`
        // },
        // {
        //     name: "Document Master",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/documentmaster`
        // },
        // {
        //     name: "Legacy Data",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/legacydata`
        // },
        // {
        //     name: "LTA",
        //     url: ''
        //     // url:  `/dashboard/${this.$route.params.entity_index}/organisation/utilities/lta`
        // },
        // {
        //     name: "Manage Financial Year",
        //     url: ''
        //     // url:  `/dashboard/${this.$route.params.entity_index}/organisation/utilities/manage_financial_year`
        // },
        // {
        //     name: "Loan",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/loans`
        // },
        // {
        //     name: "Loan Payment Summary",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/loanpaymentsummary`
        // },
        // {
        //     name: "Loan Details",
        //     url: ''
        //     // url:  `/dashboard/${this.$route.params.entity_index}/organisation/utilities/loan_details`
        // },
        // {
        //     name: "Loan Closure",
        //     url: ''
        //     // url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/loanClosure`
        // }
      ],
      breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              }
            ],
    };
  },
  methods: {
    navigateToUtility(url) {
      this.$router.push({
        path: url
      });
    },
  }
};
</script>

</style>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss";  //margins
.d-heading2 {
  padding-bottom: 7px;
  margin-bottom: 7px;
  border-bottom: solid 2px #eaeaea;
}
li {
  font-size: 14px;
  margin-left: 30px;
  a {
    text-decoration: none;
    color: inherit;
  }
}
.example-item {
  li::before {
    content: "\2022";
    color: #d8d8d8;
    font-size: 26px;
    font-weight: bold;
    display: inline-block;
    width: 24px;
    top: 3px;
    position: relative;
    margin-left: -15px;
  }
}
.grid-box {
  display: grid;
  grid-template-columns: repeat(6,1fr);
  grid-row-gap: 5px;
  // flex-direction: row;
  .btn {
    margin-right: 10px;
  }
}
.utility-container{
  display: flex;
  background-color: #FFFFFF;
  border-radius: 8px;
  border: solid 1px #efefef;
  width: 100%;
  padding: 20px;
  font-weight: bold;
  font-size: medium;
}

.cursor-pointer{
  cursor: pointer;
}
</style>
